import { createTheme } from '@project44/manifest-ds';

export const theme = createTheme({
  colors: {
    'background-primary': '#021C6B',
    'background-secondary': 'rgba(199, 204, 240, 0.15)',
    'border-primary': '#33488C',
    'palette-grey-100': '#20367F',
    'palette-grey-300': '#20367F',
    'text-primary': '#FFFFFF',
    'text-secondary': '#C7CCF0',
  },
});
